import React from 'react'
import { Group, Rect, Text } from 'react-konva'
import { useShallow } from 'zustand/react/shallow'
import { useEditorStore, OperationalZone } from '../../store/editorStore'

const COLORS = {
  safety: { fill: 'rgba(239,68,68,0.10)', stroke: '#f87171', label: 'БЕЗОПАСНОСТЬ' },
  maintenance: { fill: 'rgba(251,191,36,0.10)', stroke: '#fbbf24', label: 'ОБСЛУЖИВАНИЕ' },
  operational: { fill: 'rgba(148,163,184,0.10)', stroke: '#94a3b8', label: 'ОПЕРАЦИОННАЯ ЗОНА' },
} as const

function OperationalZoneShape({ zone, selected, scale, onSelect }: { zone: OperationalZone; selected: boolean; scale: number; onSelect: () => void }) {
  const style = COLORS[zone.kind]
  const x = zone.xM * 100
  const y = zone.yM * 100
  const w = zone.widthM * 100
  const h = zone.depthM * 100
  return (
    <Group x={x} y={y} onClick={event => { event.cancelBubble = true; onSelect() }}>
      <Rect width={w} height={h} fill={style.fill} stroke={selected ? '#fff' : style.stroke} strokeWidth={(selected ? 2 : 1) / scale} dash={[5 / scale, 3 / scale]} />
      <Text x={4 / scale} y={4 / scale} width={Math.max(0, w - 8 / scale)} text={zone.label || style.label} fontSize={Math.max(9, Math.min(13, h * 0.18)) / scale} fill={style.stroke} fontFamily="JetBrains Mono, monospace" fontStyle="bold" listening={false} />
    </Group>
  )
}

export const OperationalZonesLayer: React.FC = () => {
  const { zones, selectedIds, toggleSelected, showAisles, stageScale } = useEditorStore(useShallow(state => ({
    zones: state.dcSettings.operationalZones,
    selectedIds: state.selectedIds,
    toggleSelected: state.toggleSelected,
    showAisles: state.showAisles,
    stageScale: state.stageScale,
  })))
  if (!showAisles) return null
  return <Group>{zones.map(zone => <OperationalZoneShape key={zone.id} zone={zone} selected={selectedIds.includes(zone.id)} scale={stageScale} onSelect={() => toggleSelected(zone.id, false)} />)}</Group>
}
